import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemsListRowItemBase } from '../list-row-item-base';

@Component({
    selector: 'fi-items-list-row-item-image-icon-a',
    templateUrl: './image-icon.component.html',
    styleUrls: ['./image-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ItemsListRowItemImageIconComponent extends ItemsListRowItemBase {}
